<div class="max-w-4xl mx-auto p-8 bg-white rounded-2xl shadow-xl mt-10">
  <div class="mb-8 text-center">
      <h2 class="text-3xl font-extrabold text-gray-800">Media Manager</h2>
      <p class="text-gray-500 mt-2">Enhance your property listing with high-quality visuals and upload Multiple/Single image</p>
  </div>

<fieldset [disabled]="isUploading" [attr.aria-busy]="isUploading" class="min-w-0">
  <div class="flex flex-wrap items-center justify-between gap-4 mb-8 p-2 bg-gray-50 rounded-xl border border-gray-100">
      <div class="flex gap-2">
          <button (click)="setUploadType('gallery')" [class]="uploadType === 'gallery' ? 'bg-indigo-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'" class="px-6 py-2.5 rounded-lg font-semibold transition-all shadow-sm">
              Gallery Images
          </button>
          <button (click)="setUploadType('plan')" [class]="uploadType === 'plan' ? 'bg-indigo-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'" class="px-6 py-2.5 rounded-lg font-semibold transition-all shadow-sm">
              Floor Plan
          </button>
          <button (click)="setUploadType('video')" [class]="uploadType === 'video' ? 'bg-indigo-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'" class="px-6 py-2.5 rounded-lg font-semibold transition-all shadow-sm">
              Video
          </button>
      </div>

      <span class="text-sm font-medium px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full border border-indigo-100">
          Mode: {{ uploadType | titlecase }}
      </span>
  </div>

  <div (dragover)="isDragging = true; $event.preventDefault()" (dragleave)="isDragging = false" (drop)="onFileDropped($event)" [class.border-indigo-500]="isDragging" [class.bg-indigo-50]="isDragging" class="relative group border-2 border-dashed border-gray-300 rounded-2xl p-12 transition-all duration-300 text-center cursor-pointer hover:border-indigo-400">


      <input #fileInput type="file" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10 " (change)="onFileSelected($event)" [multiple]="uploadType === 'gallery'" [accept]="uploadType === 'video' ? 'video/*' : 'image/*'" style="height: 100% !important;" />

      <div class="space-y-4">
          <div class="mx-auto w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <svg *ngIf="uploadType !== 'video'" class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
              </svg>
              <svg *ngIf="uploadType === 'video'" class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
              </svg>
          </div>
          <div class="text-gray-600">
              <span class="font-bold text-indigo-600 hover:underline">Click to upload</span> or drag and drop
              <p class="text-xs text-gray-400 mt-1">
                  {{ uploadType === 'video' ? 'MP4, MOV (Max 50MB)' : 'PNG, JPG or WEBP (Max 5MB)' }}
              </p>
          </div>
      </div>
  </div>
  <div *ngIf="previews.length > 0" class="mt-10">
      <div class="flex items-center justify-between mb-4">
          <h4 class="text-lg font-bold text-gray-700">Selected Visuals ({{ previews.length }})</h4>
          <button (click)="clearAll()" class="text-sm text-red-500 hover:underline font-medium">Remove All</button>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" *ngIf="previews.length > 0">
          <div *ngFor="let media of previews; let i = index" class="relative group aspect-square rounded-xl overflow-hidden border border-gray-200 bg-black shadow-md">

              <video *ngIf="media.type === 'video'" [src]="media.url" class="w-full h-full object-cover" controls muted>
              </video>

              <img *ngIf="media.type === 'gallery'" [src]="media.url" class="w-full h-full object-cover transition-transform group-hover:scale-105" />

              <img *ngIf="media.type === 'plan'" [src]="media.url" class="w-full h-full object-cover transition-transform group-hover:scale-105" />

              <div class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <button (click)="removeImage(i)" class="bg-red-500 text-white p-2 rounded-full hover:scale-110 transition-transform">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-4v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                  </button>
              </div>
          </div>
      </div>
  </div>

  <div class="mt-10 pt-6 border-t border-gray-100 flex justify-end gap-3">
      <button class="px-6 py-2 text-gray-600 font-semibold hover:bg-gray-50 rounded-lg">Skip for now</button>
      <button (click)="uploadImages()" [disabled]="isUploading || selectedFiles.length === 0" class="px-8 py-2 bg-indigo-600 text-white font-bold rounded-lg shadow-lg hover:bg-indigo-700 disabled:bg-gray-300 disabled:shadow-none transition-all">
          <span *ngIf="isUploading" class="inline-block h-4 w-4 mr-2 align-middle rounded-full border-2 border-white/40 border-t-white animate-spin" aria-hidden="true"></span>
              <span>{{ isUploading ? 'Uploading…' : 'Upload ' + (uploadType === 'gallery' ? 'Gallery' : uploadType === 'plan' ? 'Floor Plan' : 'Video') }}</span>
      </button>
  </div>
</fieldset>
<div *ngIf="isUploading" role="status" aria-live="polite" class="mt-4 flex items-center gap-3 text-sm font-medium text-indigo-700">
  <span class="inline-block h-5 w-5 rounded-full border-2 border-indigo-200 border-t-indigo-600 animate-spin" aria-hidden="true"></span>
  Uploading your media. Please wait…
</div>
</div>

<div *ngIf="showUploadSuccessModal" class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-all">

  <div class="relative w-full max-w-sm p-6 bg-white rounded-2xl shadow-2xl transform transition-all animate-in zoom-in duration-300">
      
      <button (click)="showUploadSuccessModal = false" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1.5 rounded-lg transition-colors">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
      </button>

      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
          <svg class="h-10 w-10 text-green-600 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
      </div>

      <div class="text-center mb-8">
          <h3 class="text-2xl font-bold text-gray-900 leading-tight">
              {{ uploadType === 'plan' ? 'Floor Plan' : 'Gallery Photos' }} Uploaded!
          </h3>
          <p class="text-sm text-gray-500 mt-2">
              Your images have been successfully processed and attached to the property.
          </p>
      </div>

      <div class="space-y-3">
          <button (click)="uploadMore()" class="w-full flex items-center justify-center px-4 py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 transition-all active:scale-95 shadow-lg shadow-indigo-100">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
              </svg>
              Upload More Images
          </button>

          <button (click)="goToList()" class="w-full flex items-center justify-center px-4 py-3 bg-white border-2 border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-50 transition-all">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
              </svg>
              Back to Property List
          </button>

          <button (click)="propertyDetails(propertyId)" class="w-full text-sm text-indigo-600 font-semibold hover:underline transition-all">
              View Property Details
          </button>
      </div>

  </div>
</div>